import { render } from "./ProductsListPage.vue?vue&type=template&id=f2f40efa&ts=true"
import script from "./ProductsListPage.vue?vue&type=script&lang=ts"
export * from "./ProductsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__